import {inject, ProviderToken} from '@angular/core';

/**
 * `inject()` for an AngularJS service that providers.ts re-provides under its AngularJS name, e.g. 'splitService'.
 * `inject()` is typed for class and InjectionToken tokens only; a string token resolves the same way at runtime.
 *
 * Import the service class with `import type`: a value import loads the AngularJS registration file too early.
 */
export function injectLegacy<T>(name: string): T {
  return inject(name as unknown as ProviderToken<T>);
}
